// /** @jsxImportSource @emotion/react */
// import { css } from "@emotion/react";
import { Tag } from "antd";
// import logo from "../img/logo.svg";
// import school from "../img/school.jpg";
// export const LogoIcon = () => <img src={logo} alt="logo" />;
// export const SchoolIcon = () => <img src={school} alt="school" />;
export const AbsenceTag = (
  <Tag color="red" className="scoring-status-tag">
    欠
  </Tag>
);
